module.exports = __webpack_public_path__ + "img/icon-about-date-1.d5e5309c.svg";